import { Box, styled } from "@mui/material";

export const CrossWrapper = styled(Box)(() => ({
    width: '100%',
    position: 'relative',
    display: 'inline-flex'
  }))

  export const SvgContainer = styled(Box)(() => ({
    position: 'absolute',
    top: 0,
    left: 0,
    pointerEvents: 'none',
  }))